// extracted by mini-css-extract-plugin
export default {"no_data_container":"NoData_no_data_container__4ZmaX","no_data_wrapper":"NoData_no_data_wrapper__VuMpN"};